"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AuthCode = _interopRequireDefault(require("@/components/AuthCode/"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'withdrawPw',
  components: {
    AuthCode: _AuthCode.default
  },
  data: function data() {
    return {
      wForm: {}
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 获取验证码
     */
    getAuthCode: function getAuthCode() {
      this.$refs.authCode.getAuthCode({
        phone_num: this.agentInfo.phone,
        type: 8
      });
    },
    /**
     * 修改密码
     */
    postEdit: function postEdit(type) {
      var _this = this;
      var url = 'agentapi/edit_cash_pwd_save',
        params = this.wForm;
      this.$post(url, params).then(function (res) {
        _this.$message({
          message: '修改成功',
          type: 'success'
        });
      });
    }
  }
};